import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import { withRouter } from 'react-router-dom';
interface PcDownloadAppProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;

}

@inject('app', 'site', 'user')
@observer
class PCDownloadApp extends React.Component<PcDownloadAppProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        const { site, app } = this.props;
        
        return <>
            <div className={styles.downloadBox}>
                <h1 className={styles.downloadTitle}>vivo社区App<span>与热爱同行</span></h1>
                <img src={`${BASE_IMG_URL}/qrcode/download_app.png`} className={styles.codeImg} />
                <p className={styles.downloadInfo}>手机浏览器扫码下载体验或<br/>vivo应用商店搜索“vivo社区”安装体验</p>
            </div>
        </>;

    }
}

export default PCDownloadApp;